const monthYearMask = 'MMM YYYY'
const monthYearFullMask = 'MMMM YYYY'
const monthYearShortMask = 'YYYY-MM'

export {
    monthYearMask,
    monthYearFullMask,
    monthYearShortMask,
}
